import { Stack } from '@mui/material'
import React from 'react'
import EmptyState from '../../../assets/images/EmptyNotification.svg'
import TextView from '../../TextView'
function NotificationsEmptyState() {
  return (
    <Stack display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} my={20}>
        <img src={EmptyState} alt="empty" style={{height:'100px', width:'90px'}}/>
        <TextView style={{marginTop:'10px',lineHeight:'25px',fontSize:'20px', fontWeight:'700', color:'#141414', textAlign:'center'}}>Nothing to see here!</TextView>
        <TextView style={{marginTop:'4px',lineHeight:'25px',fontSize:'16px', fontWeight:'500', color:'#565556', textAlign:'center'}}>Your notification feed is empty.</TextView>

    </Stack>
  )
}

export default NotificationsEmptyState